/* eslint-disable no-console */
import React, { useEffect } from 'react';
import { Tab } from 'src/components';
import AboutTab from './AboutTab';
import ServicesTab from './ServicesTab';

const Business = () => {
  const [activeTabIndex, setActiveIndex] = React.useState(0);
  const tabData = [
    {
      id: 0,
      label: 'About',
    },
    {
      id: 1,
      label: 'Services',
    },
  ];

  return (
    <div className="grid grid-cols-12 gap-9 mt-6 text-black ">
      <div className="md:col-span-3 col-span-12   ">
        <Tab
          activeIndex={activeTabIndex}
          setActiveIndex={setActiveIndex}
          tabData={tabData}
        />
      </div>
      <div className="md:col-span-9 col-span-12">
        {activeTabIndex === 0 ? (
          <div className="rounded-xl border border-border-color-dark w-[388px] p-6 mb-10">
            <AboutTab />
          </div>
        ) : activeTabIndex === 1 ? (
          <div className="rounded-xl border border-border-color-dark w-[388px] p-6 mb-10">
            <ServicesTab />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default React.memo(Business);
